import {useSelector} from 'react-redux';
import {Breadcrumb} from '~/GalleryPB/Breadcrumb';
import {isIn3AcrossABTest} from '~/GalleryPB/experiments';
import {
  selectGalleryDataBreadcrumbs,
  selectGalleryDataPageDisplayName,
} from '~/GalleryPB/reducers/galleryData/selectors';
import {showSeoHeader} from '~/GalleryPB/utils';
import {Typography} from '~library/atoms/Typography';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import * as styles from './SeoHeaderWithBreadcrumb.module.scss';

export const SeoHeaderWithBreadcrumb = () => {
  const isLargishAndUp = useIsLargishAndUp();
  const breadcrumbs = useSelector(selectGalleryDataBreadcrumbs);
  const pageDisplayName = useSelector(selectGalleryDataPageDisplayName);
  const in3AcrossABTest = isIn3AcrossABTest();

  const seoDataObj = window.top_of_page_copy;

  if (!showSeoHeader || !in3AcrossABTest) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {!isLargishAndUp && <Breadcrumb path={breadcrumbs} className={styles.breadcrumbs} />}
      <div className={styles.content}>
        {isLargishAndUp && <Breadcrumb path={breadcrumbs} className={styles.breadcrumbs} />}
        <div className={styles.copyWrapper}>
          <Typography
            variant={isLargishAndUp ? 'header3' : 'header4'}
            as="h1"
            data-qa-id="galleryPageTitle"
          >
            {pageDisplayName}
          </Typography>
          <Typography
            variant={isLargishAndUp ? 'paragraph2' : 'paragraph3'}
            data-qa-id="gallerySeoHeaderMetadata"
          >
            {seoDataObj}
          </Typography>
        </div>
      </div>
    </div>
  );
};
